"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradingDataRequest = void 0;
var TradingDataRequest = /** @class */ (function () {
    function TradingDataRequest() {
    }
    return TradingDataRequest;
}());
exports.TradingDataRequest = TradingDataRequest;
;
//# sourceMappingURL=tradingData.request.js.map